import { render, staticRenderFns } from "./RoofPitchFormStep.vue?vue&type=template&id=85466fa4"
import script from "./RoofPitchFormStep.vue?vue&type=script&lang=js"
export * from "./RoofPitchFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports